import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const ShoppingListMenuButton = ({ url }) => {
  const shoppingList = useSelector((x) => x.shoppingList);
  return (
    <a href={url} className="shoppinglist__menu__button" aria-label={translate('go.to.shoppinglist')}>
      <svg className={`shoppinglist__icon shoppinglist__icon--menu`} aria-hidden="true">
        <use href="/ui/images/sprites/brenderup.svg#heart"></use>
      </svg>
      <div className="shoppinglist__menu__button__quantity">
        {shoppingList.length}
      </div>
    </a>
  );
};

export default ShoppingListMenuButton;
